import React from 'react'

// Types ----

export type Option = {
  name: string
  value: string | number
}

type SimpleSelectProps = {
  id: string
  name: string
  label: string
  value?: number | string | null
  onChange: (value: string | number | null) => void
  options?: Option[]
  isLoading?: boolean
  defaultOptionText?: string
}

// Component ----

export function SimpleSelect({id, name, label, value, onChange, options, isLoading, defaultOptionText = '--Choose an option--'}: SimpleSelectProps) {
  return (
    <div className='flex flex-col gap-1'>
      <label htmlFor={id} className="text-sm font-medium text-gray-700">
        {label}
      </label>
      <select
        id={id}
        name={name}
        className="rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-brand focus:outline-none focus:ring-brand sm:text-sm"
        value={value ?? undefined}
        onChange={event => onChange(event.currentTarget.value)}
      >
        <option value="">{isLoading ? 'Loading...' : defaultOptionText}</option>

        {options?.map(option => (
          <option value={option.value} key={option.value}>
            {option.name}
          </option>
        ))}
      </select>
    </div>
  );
}